/* eslint-disable max-len */
// Redux Action Types
import {
  SELECT_WIDGET_FILTES, SET_WIDGET_FILTES, SET_SELECTED_DATE, INCREMENT_SEVEN_DEYS, DECREMENT_SEVEN_DAYS,
  SET_WIDGET_FILTES_SELECTED_DATE, INCREMENT_MONTH, DECREMENT_MONTH
} from '../actions/types';
// Initial State
const initialState = { widgetFiltes: [], selectedDate: new Date().toLocaleDateString('en-US') };

export default function (state = initialState, action) {
  if (action.type === SET_WIDGET_FILTES) return { widgetFiltes: action.payload, selectedDate: state.selectedDate };
  if (action.type === SELECT_WIDGET_FILTES) {
    if (state.widgetFiltes.includes(action.payload)) {
      return { widgetFiltes: state.widgetFiltes.filter(el => el !== action.payload), selectedDate: state.selectedDate };
    }
    return { widgetFiltes: state.widgetFiltes.concat([action.payload]), selectedDate: state.selectedDate };
  }
  if (action.type === SET_SELECTED_DATE) return { widgetFiltes: state.widgetFiltes, selectedDate: action.payload };
  if (action.type === INCREMENT_SEVEN_DEYS) {
    const date = new Date(state.selectedDate);
    date.setDate(date.getDate() + 7);
    
    return { widgetFiltes: state.widgetFiltes, selectedDate: date.toLocaleDateString('en-US') };
  }
  if (action.type === DECREMENT_SEVEN_DAYS) {
    const date = new Date(state.selectedDate);
    date.setDate(date.getDate() - 7);
    return { widgetFiltes: state.widgetFiltes, selectedDate: date.toLocaleDateString('en-US') };
  }

  if (action.type === INCREMENT_MONTH) {
    const date = new Date(state.selectedDate);
    date.setMonth(date.getMonth() + 1);
    return { widgetFiltes: state.widgetFiltes, selectedDate: date.toLocaleDateString('en-US') };
  }
  if (action.type === DECREMENT_MONTH) {
    const date = new Date(state.selectedDate);
    date.setMonth(date.getMonth() - 1);
    // 12/3/2022
    return { widgetFiltes: state.widgetFiltes, selectedDate: date.toLocaleDateString('en-US') };
  }

  return state;
}
